import axios from 'axios'
import { message } from 'antd'
import i18next from '@/i18n'

let adminBaseURL = import.meta.env.VITE_ADMIN_BASE_URL

const instance = axios.create({
  baseURL: adminBaseURL,
  timeout: 100000,
})
instance.interceptors.request.use(
  (config: any) => {
    // 生产环境API地址
    // if (import.meta.env.VITE_NODE_ENV === 'production') {
    //   const realAPI_Url = sessionStorage.getItem('addressJson') || ''
    //   baseURL = `https://${realAPI_Url}`
    //   config.baseURL = baseURL
    // }
    // const token = sessionStorage.getItem('token')
    //WAY
    // config.headers['way'] = 'WEB'
    // if (token && !['/tg/user/signLogin'].includes(config.url)) {
    //   // 让每个请求携带自定义token 请根据实际情况自行修改
    //   config.headers['Authorization'] = token
    // }
    return config
  },
  (error) => {
    console.log('requestErr->', error)
  },
)

instance.interceptors.response.use(
  (response: any) => {
    if (response.status !== 200) {
      // todo error tips
      return Promise.reject()
    }
    return response.data
  },
  (error: any) => {
    if (error.response) {
      const { data } = error.response
      const { code, message } = data
      console.error('error-->', code, message)
      message.error({
        content: i18next.t(code, i18next.t('COMM_ERROR_1')),
      })
    }
  },
)

export default instance
